import React, { useMemo } from 'react';

const ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
  'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
const UMLAUT_MAP = { 'Ä': 'A', 'Ö': 'O', 'Ü': 'U' };

export const normalizeFirstLetter = (lastName) => {
  if (!lastName) return null;
  const ch = lastName.trim().charAt(0).toUpperCase();
  if (UMLAUT_MAP[ch]) return UMLAUT_MAP[ch];
  if (/[A-Z]/.test(ch)) return ch;
  return '#';
};

/**
 * A-Z-Schnellfilter-Leiste fuer die Mitarbeiterliste.
 * Klick auf einen Buchstaben filtert nach Nachname-Anfang. Buchstaben ohne
 * Treffer werden dezent ausgegraut.
 */
export const AZFilterStrip = ({ employees = [], selected = null, onSelect }) => {
  const counts = useMemo(() => {
    const acc = {};
    for (const e of employees) {
      const k = normalizeFirstLetter(e.last_name);
      if (!k) continue;
      acc[k] = (acc[k] || 0) + 1;
    }
    return acc;
  }, [employees]);

  const hasOther = (counts['#'] || 0) > 0;
  const totalActive = Object.values(counts).reduce((a, b) => a + b, 0);

  const Letter = ({ value, label, active, count, onClick, disabled }) => (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[
        'min-w-[28px] h-8 px-1.5 rounded-md text-xs font-semibold transition-colors',
        'flex items-center justify-center',
        active
          ? 'bg-primary text-primary-foreground shadow-sm'
          : count
            ? 'bg-muted/40 hover:bg-muted text-foreground'
            : 'text-muted-foreground/40 cursor-not-allowed',
      ].join(' ')}
      title={count ? `${count} Mitarbeiter` : 'Keine Mitarbeiter'}
      data-testid={`az-letter-${value}`}
    >
      {label}
    </button>
  );

  return (
    <div className="flex flex-wrap items-center gap-1 mb-3" data-testid="az-filter-strip">
      <Letter
        value="all"
        label={`Alle (${totalActive})`}
        active={!selected}
        count={totalActive}
        onClick={() => onSelect(null)}
      />
      <span className="mx-1 text-muted-foreground/40">|</span>
      {ALPHABET.map((l) => (
        <Letter
          key={l}
          value={l}
          label={l}
          active={selected === l}
          count={counts[l] || 0}
          disabled={!counts[l]}
          onClick={() => counts[l] && onSelect(l)}
        />
      ))}
      {hasOther && (
        <Letter
          value="other"
          label="#"
          active={selected === '#'}
          count={counts['#']}
          onClick={() => onSelect('#')}
        />
      )}
    </div>
  );
};
